var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-apex-charts',{ref:"barChart",attrs:{"type":"bar","height":"350","options":_vm.barChart.chartOptions,"series":_vm.barChart.series},on:{"dataPointSelection":_vm.handleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }